(function (Drupal) {

  Drupal.behaviors.varios = {
    attach: function (context, settings) {

      if (context !== document) return;

      const navbar = document.querySelector('#navbar-principal');
      if (!navbar) return;

      function updateHeaderHeightVar() {
        document.documentElement.style.setProperty(
          '--header-height',
          navbar.offsetHeight + 'px'
        );
      }

      const logoImg = navbar.querySelector('.navbar-brand img');
      if (!logoImg) return;

      const logob = "/themes/custom/berritzen/logo_b.svg";
      const logo = "/themes/custom/berritzen/logo.svg";
      const logow = "/themes/custom/berritzen/logo_w.svg";

      /* =========================
         BACKOFFICE (GIN)
      ========================== */

      if (document.body.classList.contains('gin--vertical-toolbar')) {
        navbar.classList.add('is-scrolled');
        navbar.classList.remove('navbar-light-top');
        logoImg.src = logob;
        return;
      }

      /* =========================
         FRONTEND
      ========================== */

      function logoScroll() {

        const pageTitle = document.querySelector('#page-title');
        const homeHero = document.querySelector('.view-llamada-a-la-accion');
        const hasHero = pageTitle || homeHero;

        const scrolled = window.scrollY > 10;
        const isMenuOpen = navbar.classList.contains('menu-expandido');

        if (!hasHero) {
          navbar.classList.add('is-scrolled');
          logoImg.src = logob;
          updateHeaderHeightVar();
          return;
        }

        if (isMenuOpen) {
          navbar.classList.add('is-scrolled');
          logoImg.src = logob;
          updateHeaderHeightVar();
          return;
        }

        const isLight = pageTitle?.classList.contains('bg-light');
        const isPrimary = pageTitle?.classList.contains('bg-primary');
        const isGradient = pageTitle?.classList.contains('bg-gradient');

        if (scrolled) {

          navbar.classList.add('is-scrolled');
          navbar.classList.remove('navbar-light-top');
          logoImg.src = logob;

        } else {

          navbar.classList.remove('is-scrolled');

          if (isLight) {
            navbar.classList.add('navbar-light-top');
            logoImg.src = logob;

          } else if (isPrimary || isGradient) {
            navbar.classList.remove('navbar-light-top');
            logoImg.src = logow;

          } else {
            navbar.classList.remove('navbar-light-top');
            logoImg.src = logo;
          }

        }

        updateHeaderHeightVar();
      }

      logoScroll();
      window.addEventListener('scroll', logoScroll);

      /* =========================
         MENU MOBILE
      ========================== */

      const toggler = document.querySelector('.navbar-toggler');
      const collapse = navbar.querySelector('.navbar-collapse');

      if (toggler && collapse) {

        collapse.addEventListener('shown.bs.collapse', function () {
          navbar.classList.add('menu-expandido');
          logoImg.src = logob;
        });

        collapse.addEventListener('hidden.bs.collapse', function () {
          navbar.classList.remove('menu-expandido');
          logoScroll();
        });

      }

    }
  };

})(Drupal);